import React, { useState } from 'react';

// Wrap any upload control so files can be DROPPED onto it, in addition to
// the click-to-browse picker (fleet rule 2026-07-13: every import gets
// drag-and-drop, no exceptions). `onFiles` receives the dropped FileList;
// route it to the same handler the picker uses. The wrapped control keeps
// working unchanged. Orange dashed outline while a drag hovers.
export default function DropZone({ onFiles, disabled, style, children, title, block }) {
  const [over, setOver] = useState(false);
  return (
    <span
      title={title}
      onDragOver={e => { if (disabled) return; e.preventDefault(); e.stopPropagation(); setOver(true); }}
      onDragLeave={() => setOver(false)}
      onDrop={e => {
        e.preventDefault(); e.stopPropagation(); setOver(false);
        if (disabled) return;
        if (e.dataTransfer.files && e.dataTransfer.files.length) onFiles(e.dataTransfer.files);
      }}
      style={{
        display: block ? 'block' : 'inline-block',
        outline: over ? '2px dashed #E36F2C' : 'none',
        outlineOffset: 2,
        borderRadius: 6,
        background: over ? '#FFF7ED' : 'transparent',
        ...style
      }}
    >
      {children}
    </span>
  );
}
